import { PRODUCTS } from '@/entities/product';

import { useAuthFlow } from '@/shared/auth';

export const ROLES = [
  { id: 'owner', name: 'Owner', isGlobal: true },
  { id: 'admin', name: 'Admin', isGlobal: true },
  { id: 'monitoring_admin', name: 'Monitoring Admin' },
  { id: 'monitoring_supervisor', name: 'Monitoring Supervisor' },
  { id: 'monitoring_operator', name: 'Monitoring Operator' },
  { id: 'stt_admin', name: 'Trexty Admin' },
  { id: 'stt_supervisor', name: 'Trexty Supervisor' },
  { id: 'stt_operator', name: 'Trexty Operator' },
];

export function useCurrentProductRoles() {
  const currentProductUrl = window.location.origin;
  const currentProduct = PRODUCTS.find(product => product.url === currentProductUrl);
  const { roles } = useAuthFlow();

  if (!currentProduct?.prefix)
    return [];

  const workspaceRoles = ROLES.filter(role => roles.includes(role.id));

  if (!currentProduct?.prefix)
    return workspaceRoles;

  return workspaceRoles.filter(role => role.isGlobal || role.id.startsWith(currentProduct.prefix));
}
